module.exports = __webpack_public_path__ + "static/media/launch_mooring_marker.dfcc046c.svg";